import React from "react";

// Chakra imports
import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

export default function Payouts() {
  return (
    <Box pt={{ base: "5px", md: "5px", xl: "5px" }}>
      <Outlet />
    </Box>
  );
}
